import React, { useEffect, useRef, useState } from 'react'
import toolkitPhone from '../../../assets/images/nexa-toolkit-phone.png'
import productsPhone from '../../../assets/images/nexa-products-phone.png'
import Sectionbg from "../../../assets/images/section-bg.png"

const Main = ({gredient}) => {
  const phoneStageRef = useRef(null);
  const [phonesVisible, setPhonesVisible] = useState(false);

  useEffect(() => {
    const stage = phoneStageRef.current;
    if (!stage) return undefined;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setPhonesVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.25 });

    observer.observe(stage);
    return () => observer.disconnect();
  }, []);
    
  const designBlocks = [
    { 
      title: 'Amazing Protection Products', 
      content: 'Explore thoughtfully designed protection options for you, your family, and the things that matter most.' 
    },
    { 
      title: 'Easy and Simple', 
      content: 'Get protected with a smooth, straightforward process that keeps everything easy to understand.' 
    },
    { 
      title: 'User-Friendly Design', 
      content: 'Enjoy a clean, intuitive experience that makes finding and managing your protection feel effortless.' 
    }
  ];

  return (
    <>
        <section className={`row_am modern_ui_section ${gredient && "gredient-bg"}`} >
            {gredient &&
            <div className="modernui_section_bg modernui-gredient"> <img src={Sectionbg} alt="image"/> </div>}
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="ui_text">
                        <div className="section_title" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="100">
                            <h2>Protect what <span> matters most to you</span></h2>
                            <p>
                            Welcome to a revolutionary leap in the world of insurance protection – a cutting-edge platform that brings the future of safeguarding your assets and well-being right to your fingertips. We are thrilled to present to you the most advanced and comprehensive insurance application, designed to redefine the way you protect yourself, your family, and your community.
                            </p>
                        </div>
                        <ul className="design_block">
                          {designBlocks.map((block, index) => (
                            <li key={index} data-aos="fade-up" data-aos-duration="1500">
                              <h4>{block.title}</h4>
                              <p>{block.content}</p>
                            </li>
                          ))}
                        </ul>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div
                          ref={phoneStageRef}
                          className={`ui_images modern_phone_stage${phonesVisible ? ' phones-visible' : ''}`}
                        >
                          <div className="modern_phone_crop modern_phone_products">
                            <img className="modern_phone_image" src={productsPhone} alt="Nexa products screen in an iPhone frame" />
                          </div>
                          <div className="modern_phone_crop modern_phone_toolkit">
                            <img className="modern_phone_image" src={toolkitPhone} alt="Nexa sales toolkit screen in an iPhone frame" />
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Main
